import { Download } from 'react-feather'
import { Oval } from 'react-loader-spinner'
import { SvgIcon } from '../../../../../../shared/icons'
import { Message } from '../../../../../../types/api'
import DecryptedMessage from './DecryptedMessage'
import LinkifyText from '../../../../../../shared/LinkifyText'

const FileMessage = ({ message }: { message: Message }) => {
  const handleDownload = (e: React.MouseEvent) => {
    e.preventDefault()
    if (message.file_url) {
      const link = document.createElement('a')
      link.href = message.file_url
      link.download = message.content || 'download'
      document.body.appendChild(link)
      link.click()
      try {
        document.body.removeChild(link)
      } catch (error) {
        console.warn('Failed to remove download link:', error)
      }
    }
  }

  // Check if file is being uploaded
  const isUploading = message.uploadStatus === 'uploading'
  const isFailed = message.uploadStatus === 'failed'

  // No numeric progress shown — only spinner

  // Get filename from metadata - handle array or single metadata
  let filename = 'file'
  if (message.metadata) {
    if (Array.isArray(message.metadata)) {
      // If metadata is an array, use the first item's filename
      filename = (message.metadata[0]?.original_filename as string) || 'file'
    } else if (typeof message.metadata === 'object') {
      // If metadata is object, check for original_filename
      filename = (message.metadata.original_filename as string) || 'file'
    }
  }

  return (
    <div className={'fileMessageWrapper'}>
      <div className={`fileMessageContainer ${isUploading ? 'uploading' : ''} ${isFailed ? 'failed' : ''}`}>
        {isUploading && (
          <div className={'fileMessageProgressOverlay'}>
            <Oval
              visible={true}
              height="40"
              width="40"
              ariaLabel="Loading"
              wrapperClass={'loaderWrapper'}
              color="#0066FF"
            />
          </div>
        )}

        {isFailed && (
          <div className={'uploadFailedOverlay'}>
            <div className={'failedIcon'}>
              <SvgIcon iconId="trash" className="fill-danger" />
            </div>
          </div>
        )}

        <div className={'fileIconWrapper'} style={{ opacity: isUploading ? 0.5 : 1 }}>
          <SvgIcon iconId="file" className="file-icon" />
        </div>
        <div className={'fileInfo'} style={{ opacity: isUploading ? 0.5 : 1 }}>
          <div className={'fileName'}>{filename}</div>
        </div>
        {!isUploading && !isFailed && (
          <button className={'downloadBtn'} onClick={handleDownload} aria-label="Download file">
            <Download size={18} />
          </button>
        )}
      </div>
      {message.content && (
        <h5>
          <DecryptedMessage message={message}>
            {(decryptedContent) => <LinkifyText text={decryptedContent} />}
          </DecryptedMessage>
        </h5>
      )}
    </div>
  )
}

export default FileMessage
